/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  WSTETHPriceProvider,
  WSTETHPriceProviderInterface,
} from "../WSTETHPriceProvider";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract IPriceProvidersRepository",
        name: "_priceProvidersRepository",
        type: "address",
      },
      {
        internalType: "contract IStETHLike",
        name: "_stETH",
        type: "address",
      },
      {
        internalType: "address",
        name: "_wstETH",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "AssetNotSupported",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidAssetAddress",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidSTETHAddress",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidWSTETHAddress",
    type: "error",
  },
  {
    inputs: [],
    name: "TokenIsNotAContract",
    type: "error",
  },
  {
    inputs: [],
    name: "ASSET",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "STETH",
    outputs: [
      {
        internalType: "contract IStETHLike",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "assetSupported",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "getPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "price",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "priceProviderPing",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "priceProvidersRepository",
    outputs: [
      {
        internalType: "contract IPriceProvidersRepository",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "quoteToken",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

type WSTETHPriceProviderConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: WSTETHPriceProviderConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class WSTETHPriceProvider__factory extends ContractFactory {
  constructor(...args: WSTETHPriceProviderConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "WSTETHPriceProvider";
  }

  deploy(
    _priceProvidersRepository: string,
    _stETH: string,
    _wstETH: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<WSTETHPriceProvider> {
    return super.deploy(
      _priceProvidersRepository,
      _stETH,
      _wstETH,
      overrides || {}
    ) as Promise<WSTETHPriceProvider>;
  }
  getDeployTransaction(
    _priceProvidersRepository: string,
    _stETH: string,
    _wstETH: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _priceProvidersRepository,
      _stETH,
      _wstETH,
      overrides || {}
    );
  }
  attach(address: string): WSTETHPriceProvider {
    return super.attach(address) as WSTETHPriceProvider;
  }
  connect(signer: Signer): WSTETHPriceProvider__factory {
    return super.connect(signer) as WSTETHPriceProvider__factory;
  }
  static readonly contractName: "WSTETHPriceProvider";
  public readonly contractName: "WSTETHPriceProvider";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): WSTETHPriceProviderInterface {
    return new utils.Interface(_abi) as WSTETHPriceProviderInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): WSTETHPriceProvider {
    return new Contract(address, _abi, signerOrProvider) as WSTETHPriceProvider;
  }
}
